<script lang="ts" setup>
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';
import { GpFadeTransition, GpToastsWrapper } from '@gportal/uikit';
import Header from './modules/Module.Header.vue';
import useSystemStatus from './composables/useSystemStatus';

const sessionStore = useSessionStore();

useSystemStatus({
  ignoreLocalDismissed: true,
  immediate: false,
});
</script>

<template>
  <GpToastsWrapper />
  <GpFadeTransition>
    <Header v-if="sessionStore.isSessionReady" />
  </GpFadeTransition>
  <router-view />
</template>

<style lang="scss">
/* TODO: Might think about moving this to our CDN but for now it's fine since we
     can cache this all on CF and Browser for 1y. */

@use 'gpcore-uikit/styles/icons/flags.scss' as *;
</style>
